import {
  Component,
  DestroyRef,
  DOCUMENT,
  Inject,
  Renderer2,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { SelectButtonModule } from 'primeng/selectbutton';
import { Language } from '../../enums/language.enum';
import { FormsModule } from '@angular/forms';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { filter } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    SelectButtonModule,
    CommonModule,
    FormsModule,
    RouterModule,
    TranslateModule,
  ],
  templateUrl: './header.html',
  styleUrls: ['./header.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppHeader {
  transparent: boolean;
  hasNoBack = true;
  current: ActivatedRoute;

  private readonly destroyRef = inject(DestroyRef);

  constructor(
    private router: Router,
    private translate: TranslateService,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.current = this.route.root;

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.syncHeaderFromRouter());

    // Initial navigation may finish before or after this constructor; reading
    // `router.routerState` reflects the full tree once navigation has completed.
    if (this.router.navigated) {
      this.syncHeaderFromRouter();
    }
  }

  private syncHeaderFromRouteLeaf(leaf: ActivatedRouteSnapshot): void {
    this.hasNoBack = !!leaf.data['hasNoBack'];
  }

  private syncHeaderFromRouter(): void {
    const leafSnapshot = this.deepestSnapshot(
      this.router.routerState.snapshot.root
    );
    this.syncHeaderFromRouteLeaf(leafSnapshot);

    let current = this.route.root;
    while (current.firstChild) {
      current = current.firstChild;
    }
    this.current = current;
  }

  private deepestSnapshot(
    snapshot: ActivatedRouteSnapshot
  ): ActivatedRouteSnapshot {
    let s = snapshot;
    while (s.firstChild) {
      s = s.firstChild;
    }
    return s;
  }

  langs: any[] = [
    { label: 'EN', language: Language.EN },
    { label: 'AR', language: Language.AR },
  ];

  language: string = localStorage.getItem('lang') || Language.EN;

  backHome() {
    const shipmentId = this.current.snapshot.params['id'];
    void this.router.navigate([`/shipment/${shipmentId}/shipping`]);
  }

  onLangChange(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
    this.renderer.setAttribute(
      this.document.body,
      'dir',
      lang == Language.AR ? 'rtl' : 'ltr'
    );
  }
}
